<template>
    <div id="base-setting">
        <h1>基础设置</h1>
    </div>
</template>

<script>
// import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"BaseSetting",
    data () {
        return {
            
        };
    },
    methods: {

    }
}

</script>
<style lang="less" scoped>
    #base-setting {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
    }
</style>